// TEMPORARY: bridges @nuxtjs/auth-next's own Vuex module (`auth`) across
// reloads. @nuxtjs/auth-next registers this module itself and only keeps
// its state on reload if store.state.auth already has a value at that
// point (see its preserveState check in _initState()) - this plugin's only
// job is putting that value there before the module registers.
// Delete this file (and its nuxt.config.js registration) when
// @nuxtjs/auth-next is removed - nothing else needs it.
import createPersistedState from 'vuex-persistedstate';
import { defineNuxtPlugin } from '~/.nuxt/imports';

export default defineNuxtPlugin(({ nuxt2Context: { store } }) => {
  createPersistedState({
    key: 'BAMauth',
    paths: ['auth']
  })(store);
});
